import React from "react";
import { useTranslation } from "react-i18next";
import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonTooltip,
} from "shared/components/button/ToggleButton";

export interface EqualizedViewToggleButtonProps {
  isEqualizedView: boolean;
  setIsEqualizedView: (isEqualizedView: boolean) => void;
  size?: "sm" | "lg";
  actualTooltip?: string;
  equalizedTooltip?: string;
}

export const EqualizedViewToggleButton: React.FC<
  EqualizedViewToggleButtonProps
> = ({
  isEqualizedView,
  setIsEqualizedView,
  size = "sm",
  actualTooltip: actualTooltipProp,
  equalizedTooltip: equalizedTooltipProp,
}) => {
  const { t } = useTranslation(["common"]);
  const actualTooltip =
    actualTooltipProp ?? t("common:equalizedViewToggle.actualTooltip");
  const equalizedTooltip =
    equalizedTooltipProp ?? t("common:equalizedViewToggle.equalizedTooltip");
  return (
    <ToggleButtonGroup
      size={size}
      variant="timeframe"
      value={isEqualizedView ? "equalized" : "actual"}
      onChange={(value) => setIsEqualizedView(value === "equalized")}
      isRequired={true}
    >
      <ToggleButton value="actual">
        {t("common:equalizedViewToggle.actualView")}
        <ToggleButtonTooltip label={actualTooltip} />
      </ToggleButton>
      <ToggleButton value="equalized">
        {t("common:equalizedViewToggle.equalizedView")}
        <ToggleButtonTooltip label={equalizedTooltip} />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
